import * as React from 'react';
import { path } from 'ramda';
import { smoothScrollIntoView } from '@cian/valuation-utils-component';

import { scrollingContext } from '../context';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';

export const useScrollToBlock = () => {
  const { refBlocksState } = React.useContext(scrollingContext);

  return React.useCallback(
    (blockId: EScrollingBlocks) => {
      const block = path<HTMLDivElement>([blockId, 'ref', 'current'], refBlocksState);
      if (block) {
        smoothScrollIntoView(block, 32);
      }
    },
    [refBlocksState],
  );
};
